import Annotation from "./annotation";

class CircularPattern extends Annotation {
  constructor() {
    super();

    this.color = "#00b0f0";
    this.lineWidth = 1;
    this.canvasSize = null;
    this.slice = null;
    // circle
    this.centerX = 0;
    this.centerY = 0;
    this.radius = 0;
    // triangle
    this.overlayTriangleSize = 8;
    this.half = 0;
    this.top = 0;
    this.triangleStartPoint = null;
    this.seg1 = null;
    this.seg2 = null;
    this.seg3 = null;

  }

  draw(ctx) {
    if (!this.canvasSize || !this.slice) 
      return;
    
      ctx.lineWidth = this.lineWidth;
      ctx.strokeStyle = this.color;
      ctx.fillStyle = this.color;
      
      this.updateCircularPattern();
      this.drawCircle(ctx)
      this.drawTriangle(ctx)
  }

  drawCircle(ctx){
    ctx.beginPath();
      ctx.arc(this.centerX, this.centerY, this.radius, 0, 2 * Math.PI);
      ctx.stroke();
      ctx.closePath();
  }
  
  drawTriangle(ctx){
    ctx.beginPath();
    ctx.moveTo(this.triangleStartPoint.x, this.triangleStartPoint.y);
    ctx.lineTo(this.seg1.x, this.seg1.y);
    ctx.lineTo(this.seg2.x, this.seg2.y);
    ctx.lineTo(this.seg3.x, this.seg3.y);
    ctx.stroke();
    ctx.fill();
    ctx.closePath();
  }

  updateSlices(slices) {
    if(slices.length == 1){
      this.slice = slices[0];    
      this.signalReady();
    }
  }

  updateCircularPattern(){
    this.centerX = this.slice.endPoint.x * this.canvasSize.w;
    this.centerY =  this.slice.endPoint.y * this.canvasSize.h;
    this.radius =  Math.abs(this.slice.endPoint.x - this.slice.startPoint.x) * this.canvasSize.w;

    this.updateTriangle();
  }

  updateTriangle(){
    this.half = this.overlayTriangleSize / 2.0;
		this.top = this.half / Math.cos(Math.PI / 3.0);

    this.triangleStartPoint = { x: this.slice.startPoint.x * this.canvasSize.w - this.half, y: this.slice.startPoint.y * this.canvasSize.h};
 
    this.seg1 = {x: this.slice.startPoint.x * this.canvasSize.w + this.half, y: this.slice.startPoint.y * this.canvasSize.h};

    this.seg2 = {x: this.slice.startPoint.x * this.canvasSize.w, y: this.slice.startPoint.y * this.canvasSize.h - this.top};

    this.seg3 = this.triangleStartPoint;

  }
}

export default CircularPattern;